import type {TenantConfig} from '@/shared/features/tenants/tenant.model';

export const tenantConfig: TenantConfig = {
   id: 'g2a',
   name: 'Gateway2Achieve',
   domain: 'gateway2achieve.com',
   supportEmail: '',
   features: {
      landing: true,
      studentCenter: true,
      dashboard: true,
      orders: true,
   },
};
